import React, { useEffect, useRef, useState } from "react";
import WorkspaceDropdown from "../Dropdown/WorkspaceDropdown";
import profile from "../../../assets/profile.svg";
// import logoutIcon from "../../../assets/logout.svg";
import { useAuth } from "../../../hooks/useAuth";
import { BiBell } from "react-icons/bi";
import { RxDotFilled } from "react-icons/rx";
import { IoClose } from "react-icons/io5";

const Nav = ({
  showWorkspaceDetails,
  setAddWorkspaceModal,
  workspaces,
  setEditWorkspaceModal,
  workspaceName,
  setWorkspaceName,
  description,
  setDescription,
  users,
  setUsers,
  privateWorkspace,
  setPrivateWorkspace,
  setSelectedUsers,
  selectedUsers,
  workspaceId,
  setWorkspaceId,
  setWorkspaceUsers,
}) => {
  const { user, logout } = useAuth();
  const [notification, setNotification] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Clicked outside the dropdown, so close it
      setNotification(false);
    }
  };

  useEffect(() => {
    // Attach the event listener when the component mounts
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    logout();
  };

  const notificationArr = [
    {
      item: "2 Errors Detected in the current campaign data.",
      date: "5 Sep 2024",
    },
    {
      item: "Impression Field has 5 Integrity Errors.",
      date: "5 Sep 2024",
    },
    {
      item: "Task has been successfully scheduled",
      date: "4 Sep 2024",
    },
  ];

  console.log(notification, "notification");
  return (
    <nav className="fixed top-0 left-0 h-[50px] right-0 bg-gradient-to-r from-[#00C8AD] to-[#0078C5] z-30">
      <div className="flex justify-between items-center h-full px-5">
        <div className="text-white text-[22px]">Ignitho Data Accelerator</div>
        {showWorkspaceDetails ? (
          <div className="flex gap-5 items-center">
            <div>
              <WorkspaceDropdown
                options={workspaces}
                selectedValue={
                  user?.current_workspace
                    ? user.current_workspace
                    : workspaces[0]
                }
                placeholder="Select Workspace"
                width="w-[160px]"
                dropdownWidth="w-[240px]"
                setAddWorkspaceModal={setAddWorkspaceModal}
                setEditWorkspaceModal={setEditWorkspaceModal}
                workspaceName={workspaceName}
                setWorkspaceName={setWorkspaceName}
                description={description}
                setDescription={setDescription}
                users={users}
                setUsers={setUsers}
                setPrivateWorkspace={setPrivateWorkspace}
                privateWorkspace={privateWorkspace}
                selectedUsers={selectedUsers}
                setSelectedUsers={setSelectedUsers}
                workspaceId={workspaceId}
                setWorkspaceId={setWorkspaceId}
                setWorkspaceUsers={setWorkspaceUsers}
              />
            </div>
            {/* notification */}
            <div className="relative text-sm mt-[5px]">
              {notificationArr.length !== 0 ? (
                <button
                  className="relative"
                  onClick={() => setNotification(true)}
                >
                  <RxDotFilled
                    color="red"
                    className="absolute left-[7px] top-[-3px]"
                    size={17}
                  />
                  <BiBell color="white" size={23} />
                </button>
              ) : (
                <button onClick={() => setNotification(true)}>
                  <BiBell color="white" size={23} />
                </button>
              )}

              {notification ? (
                <>
                  {notificationArr.length !== 0 ? (
                    <div
                      className="bg-white absolute border border-lite-grey-4 right-0 rounded-md top-8 max-w-sm break-words"
                      ref={dropdownRef}
                    >
                      <div className="max-h-[250px] overflow-y-auto ">
                        <ul className="w-[350px]">
                          {notificationArr.map((value) => (
                            <>
                              <li className="flex justify-between items-center px-2 py-3">
                                <span className="text-xs flex mr-2">
                                  <span>
                                    <RxDotFilled color="red" size={20} />
                                  </span>
                                  <span>
                                    <div>{value.item}</div>
                                    <div className="text-[9px] text-[#707070]">
                                      {value.date}
                                    </div>
                                  </span>
                                </span>
                                <span>
                                  <IoClose
                                    className="cursor-pointer"
                                    color="#707070"
                                  />
                                </span>
                              </li>
                              <hr />
                            </>
                          ))}
                          <li className="px-2 py-3 text-center text-xs text-[#0083BF] font-semibold cursor-pointer">
                            View All
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="bg-white absolute border border-lite-grey-4 right-0 rounded-md w-[200px] top-9 p-4"
                      ref={dropdownRef}
                    >
                      No results
                    </div>
                  )}
                </>
              ) : (
                ""
              )}
            </div>

            <div className="font-medium relative text-sm group">
              <img src={profile} alt="profile" className="w-6 h-6" />
              <div className="bg-white absolute border invisible border-lite-grey-4 group-hover:visible right-0 rounded-md z-20 top-6">
                <ul className="z-10 bg-white max-h-[85px] overflow-y-auto rounded-t-lg">
                  <li className="text-sm px-2.5 py-2.5 overflow-hidden text-ellipsis flex justify-center text-lite-black whitespace-nowrap">
                    {user?.name}
                  </li>
                  <li
                    className="px-2.5 py-2 rounded-md overflow-hidden m-0.5 flex justify-center gap-2 cursor-pointer text-ellipsis whitespace-nowrap bg-[#0083BF] hover:bg-[#00578F] text-white"
                    onClick={() => handleLogout()}
                  >
                    {/* <img src={logoutIcon} alt="logout"/> */}
                    Logout
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </nav>
  );
};

export default Nav;
